module.exports = __webpack_public_path__ + "media/images/csv_file-f275c4add21bcaeaf34052b8f8268215.png";